import { Component } from 'preact';
import { NavigationFinalLinks } from './navigationFinalLink';
import { NavigationBase } from './navigationBase';

class NavigationSubLinks extends Component {
  getSubItemPermissions = (subItem) => {
    let subItemPermissions = subItem.Permissions ? subItem.Permissions : [];
    subItemPermissions = subItemPermissions.concat(...(this.getFinalItemPermissions(subItem)))
    return subItemPermissions;
  }

  getFinalItemPermissions = (subItem) => {
    return subItem.FinalItems ? subItem.FinalItems.map(f => {
      return f.Permissions ? f.Permissions : [];
    }) : []
  }

  // the user has permission to view the item, or any sub item or final item on it
  userHasPermission = (subItem, account) => {
    const subItemPermissions = this.getSubItemPermissions(subItem);

    if (!account || !account.Permissions) {
      return false;
    }

    if (!subItemPermissions || subItemPermissions.length <= 0) {
      return true;
    }

    const currentUserPermissions = account.Permissions;

    // the user must have at least one of the permissions to have access
    const isPermitted = subItemPermissions.some((permissionRequired) => {

      // return currentUserPermissions.indexOf(permissionRequired) !== -1
      return (currentUserPermissions.map((permission) => {
        return !permissionRequired || (permission.Action === permissionRequired.Action &&
          permission.Name === permissionRequired.Name &&
          permission.Prefix === permissionRequired.Prefix &&
          permission.UserType === permissionRequired.UserType);
      }).filter(m => m)).length > 0;
    });

    return isPermitted
  }

  render(props, state) {
    let account = props.account;
    let userHasPermission = (subItem, account) => this.userHasPermission(subItem, account);

    if (!props.item.SubItems) {
      return null
    }

    return <div>
        { props.item.SubItems.map(function(subItem, index) {
          const hasPermission = userHasPermission(subItem, account);

          subItem.quickAccess = [props.item.quickAccess[0], index]
          const linkAction = e => {
            if(!!subItem.FinalItems && subItem.FinalItems.length > 0) {
              props.toggleMenuSubItem(subItem.Name)
            } else {
              props.setPathActive(props.item.Name, subItem.Name)
              props.navigationCallback(subItem.Path)
            }
          }

          const open = props.openedMenuItems.subItems.indexOf(subItem.Name) >= 0;
          const active = (
            props.activatedPath.item === props.item.Name &&
            props.activatedPath.subItem === subItem.Name
          )

          return (
            <div>
            {/* This sub item is not external link*/}
            {hasPermission && !subItem.External &&
              <div>
                <div onClick={linkAction} className={"navigation-sub-link" + (active? " active" : " " )}>
                  <NavigationBase removeMenuItem={props.removeMenuItem} dropdown={!!subItem.FinalItems && subItem.FinalItems.length > 0} open={open} item={subItem}></NavigationBase>
                </div>
                {/* This sub item is open and has nested final items*/}
                { open && !!subItem.FinalItems &&
                  <div>
                    <NavigationFinalLinks
                      activatedPath={props.activatedPath}
                      item={props.item}
                      removeMenuItem={props.removeMenuItem}
                      subItem={subItem}
                      finalItems={subItem.FinalItems}
                      navigationCallback={props.navigationCallback}
                      setPathActive={props.setPathActive}
                      account={props.account}>
                    </NavigationFinalLinks>
                  </div>
                }
              </div>
            }
            {/* This sub item is an external link*/}
            {hasPermission && subItem.External &&
              <a href={subItem.Path} className={"navigation-sub-link external-link"}>
                <NavigationBase removeMenuItem={props.removeMenuItem} dropdown={false} open={false} item={subItem}></NavigationBase>
              </a>
            }
            </div>
          )
        }) }
      </div>
  }
}

export {NavigationSubLinks};



// WEBPACK FOOTER //
// ./components/sidebar/navigationSubLink.js